function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m 221.31,297.18 c -5.59,-6.92 -11,-13.28 -16,-19.89 -16.61,-21.77 -29.89,-45.34 -38.21,-71.53 a 181.63,181.63 0 0 1 -8.31,-66.44 c 1.58,-26.49 8.93,-51.38 20.59,-75 a 232.1,232.1 0 0 1 37.14,-54.17 c 1.46,-1.59 2.89,-3.2 4.65,-5.15 3.74,4.09 7.24,7.69 10.48,11.5 a 231.63,231.63 0 0 1 36,57.45 197,197 0 0 1 15.11,54.21 174.77,174.77 0 0 1 0.36,41.77 191.05,191.05 0 0 1 -13.51,51.88 239.44,239.44 0 0 1 -31.11,53.74 c -5.24,6.88 -10.88,13.46 -16.33,20.19 a 12.64,12.64 0 0 0 -0.86,1.44 z m -2.6,-278.19 c -0.16,0.18 -0.33,0.35 -0.47,0.54 a 295.22,295.22 0 0 0 -34.76,56.35 c -8.08,17.39 -14.16,35.37 -15.66,54.65 -0.11,1.36 -0.17,2.72 -0.21,4.08 -0.04,1.36 0,2.66 0,4.21 8.4,-43.87 29.19,-82.07 51.1,-119.83 z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m 288.43,255.77 c 35,-62.88 39.48,-127.5 11.11,-194.29 l 66.07,-31.13 c 1.19,4.78 2.38,9.31 3.44,13.88 a 252.14,252.14 0 0 1 6.93,59.82 185.94,185.94 0 0 1 -11,62.67 169.8,169.8 0 0 1 -56,76 c -6.43,4.86 -13.31,9.11 -20,13.64 z m 60.52,-64.66 c 6.93,-12.71 16.67,-38.26 19.34,-71.86 1.64,-20.61 -2.58,-64.11 -8,-74 a 311.22,311.22 0 0 1 3,73.77 293.6,293.6 0 0 1 -14.34,72.09 z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m 145.46,61.95 c -28.65,65.64 -25.57,129.75 8.17,192.91 a 18.43,18.43 0 0 1 -2,-0.88 169.58,169.58 0 0 1 -81.27,-121.84 205.82,205.82 0 0 1 0.35,-64 c 2,-12.08 4.85,-24 7.33,-36 0.1,-0.45 0.29,-0.89 0.56,-1.75 z M 94.16,189.27 C 79.3,142.13 76.26,94.1 83.34,45.32 70.72,94.5 72.38,142.62 94.16,189.27 Z",
  fill: "currentColor"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m 281.9,300.8 c 4.19,-1.92 8.41,-3.78 12.57,-5.77 a 176.17,176.17 0 0 0 39.44,-26.38 c 20.38,-17.75 37,-38.66 50.61,-61.9 4.09,-7 7.61,-14.27 11.32,-21.45 0.57,-1.1 1,-1.82 2.47,-1.55 13.45,2.5 26.91,4.93 40.76,7.46 -9.71,29.28 -24.47,55 -48.13,75 -31.48,26.47 -68.33,36.57 -109.04,34.59 z m 145.64,-93.29 c -18,28.31 -38.63,54.24 -65.87,74.38 31.46,-16.34 51.11,-43.17 65.87,-74.38 z",
  fill: "currentColor"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m 5,191.23 24.73,-4.53 c 5,-0.91 9.93,-1.78 14.87,-2.78 1.88,-0.39 3,-0.18 3.9,1.83 a 244.64,244.64 0 0 0 24,41 241.75,241.75 0 0 0 35.73,40.15 185.51,185.51 0 0 0 42.91,28.94 c 3,1.46 6.16,2.7 9.24,4 a 5.58,5.58 0 0 1 1.76,1.1 C 126.43,302.76 93.29,294.85 63.73,274.32 34.17,253.79 16.28,225.13 5,191.23 Z m 11.54,16.29 c 14.75,31.19 34.39,58 65.89,74.38 C 55.19,261.78 34.51,235.85 16.54,207.52 Z",
  fill: "currentColor"
});

var SvgStandard = function SvgStandard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 444.07 306.19298",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStandard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/standard.87e7aab2.svg";
export { ForwardRef as ReactComponent };